import React from "react";

// Single source-of-truth logo: one outlined SVG (no font dependency),
// scaled only via CSS. Magenta is baked into the file (#C724FF) so it is
// guaranteed identical in every placement. Vector => crisp on retina/2x.
export const Wordmark = ({ className = "h-5", testid = "wordmark" }) => {
  return (
    <img
      src="/logo.svg"
      alt="VYNLWORLD"
      data-testid={testid}
      draggable="false"
      className={`w-auto select-none ${className}`}
    />
  );
};

export default Wordmark;
